export default function validate(videogame){
    let errors = {}
    if(!videogame.name){
        errors.name = "Name is required"
    } else if(!/(http)?s?:?(\/\/[^"']*\.(?:png|jpg|jpeg|gif|png|svg))/.test(videogame.image)){
        errors.image = "URL image must be formatted correctly"
    } else if(!/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/.test(videogame.releasedDate)){
        errors.releasedDate = "Released Date must be formatted correctly"
    } else if((Number.isNaN(Number(videogame.rating)))){
        errors.rating = "Rating must be a number"
    } else if(videogame.rating<0){
        errors.rating = "Rating must be greater than 0"
    } else if(videogame.rating>5){
        errors.rating = "Rating must be less than 5"
    } else if(videogame.rating==""){
        errors.rating = "Rating must be a number"
    } else if(videogame.genres.length==0){
        errors.genres = "You must choose at least one genre"
    } else if(videogame.platform.length==0){
        errors.platform = "You must choose at least one platform"
    }

    return errors
}